import { render, staticRenderFns } from "./desuLimitClassifyAction.vue?vue&type=template&id=af0fc57e&scoped=true"
import script from "./desuLimitClassifyAction.vue?vue&type=script&lang=js"
export * from "./desuLimitClassifyAction.vue?vue&type=script&lang=js"
import style0 from "./desuLimitClassifyAction.vue?vue&type=style&index=0&id=af0fc57e&prod&scoped=true&lang=css"
import style1 from "./desuLimitClassifyAction.vue?vue&type=style&index=1&id=af0fc57e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0fc57e",
  null
  
)

export default component.exports